// extracted by mini-css-extract-plugin
export default {"teamContainer":"TeamContainer_teamContainer__jUJ4T"};